/* eslint-disable react/no-array-index-key */

import React from 'react';
import { Button, Image, Typography } from 'tfc-components';

import team1 from 'assets/images/aboutUs/team1.png';
import team2 from 'assets/images/aboutUs/team2.png';
import team3 from 'assets/images/aboutUs/team3.png';
import team4 from 'assets/images/aboutUs/team4.png';
import Section from 'components/organisms/Section';

interface ITeam {
  image: string;
  title: string;
  description: string;
}

/* Fake data */
const data: ITeam[] = [
  {
    image: team1,
    title: 'Product builders',
    description: 'who love the messy 0→1 stage',
  },
  {
    image: team2,
    title: 'AI researchers',
    description: 'who turn capability into utility',
  },
  {
    image: team3,
    title: 'Designers',
    description: 'who translate insight into experience',
  },
  {
    image: team4,
    title: 'Engineers',
    description: 'who ship fast, without cutting corners',
  },
];
const Team:React.FC = () => (
  <Section>
    <Section.Title>The Team</Section.Title>

    <div className="p-about_team_list">
      {data.map((item, index) => (
        <div className="p-about_team_item" key={index}>
          <Image alt={item.title} imgSrc={item.image} ratio={1} />
          <Typography.Text
            fontweight="400"
            extendClasses="f-24x36 p-about_team_description"
          >
            <Typography.Text
              type="span"
              fontweight="600"
              extendClasses="f-24x36 p-about_team_title"
            >
              {item.title}
            </Typography.Text>
            {' '}
            {item.description}
          </Typography.Text>
        </div>
        ))}
    </div>

    <div className="p-about_team_join">
      <Typography.Text fontweight="600" extendClasses="f-18x24">
        Want to build with us?
      </Typography.Text>
      <Button extendClasses="fButton ">Join now</Button>
    </div>
  </Section>
  );

export default Team;
